<fui-nav-layout>
    <fui-canvas-masthead>
        <fui-chrome>
            <fui-chrome-actions *ngIf="!WhoAmI.beaconScanOnly">
                <fui-navigation-chrome-action (click)="hamburgerClicked()"></fui-navigation-chrome-action>
            </fui-chrome-actions>
            <fui-chrome-branding>
                <fui-mark-logo id="chrome-logo" [type]="'fedelta'" (click)="logoClicked()"></fui-mark-logo>
                <fui-header-form-context *ngIf="false && (Config.API_INSTANCE_REGISTERED | booleanConfig)"
                                         class="integrated-instances">
                    <fui-mark-logo type="chewzie" class="integrated-instances-select"></fui-mark-logo>
                    <wbo-integrated-instance-single-select-control [standalone]="true"
                                                                   [allowClearSelectionOption]="false"
                                                                   [(value)]="integratedInstanceUrl"
                                                                   (valueChange)="integratedInstanceSelected($event)"></wbo-integrated-instance-single-select-control>
                </fui-header-form-context>
            </fui-chrome-branding>
            <fui-chrome-controls id="chrome-controls">
                <wbo-localisation-chrome-control *ngIf="(Config.LOCALISATION | booleanConfig) && !WhoAmI.beaconScanOnly" id="chrome-localisation-control"></wbo-localisation-chrome-control>
                <wbo-notification-chrome-control *ngIf="!WhoAmI.beaconScanOnly"></wbo-notification-chrome-control>
                <wbo-user-profile-chrome-control id="chrome-account-control"></wbo-user-profile-chrome-control>
            </fui-chrome-controls>
        </fui-chrome>
    </fui-canvas-masthead>
    <fui-canvas-window>
        <fui-canvas-frame *ngIf="!WhoAmI.beaconScanOnly">
            <fui-navigation id="navigation"></fui-navigation>
        </fui-canvas-frame>
        <fui-canvas-storyboard>
            <router-outlet></router-outlet>
        </fui-canvas-storyboard>
    </fui-canvas-window>
</fui-nav-layout>
